import { resolvePathOnCurrentHost } from './resolvePathOnCurrentHost'
import { history } from './router'

export const pushRoute = (pathToNavigateTo: string, resetParams = false) => {
  const nextUrl = resolvePathOnCurrentHost(pathToNavigateTo, window.location.href, resetParams)

  if (resetParams) {
    window.location.replace(nextUrl)

    return
  }

  history.push(nextUrl)
}
